import React from 'react';
import { CloudSnow, Cloud, Sun } from 'lucide-react';
import { format, addHours } from 'date-fns';
import { fr } from 'date-fns/locale';
const hourlyForecast = Array.from({
  length: 24
}, (_, i) => {
  const time = addHours(new Date(), i);
  const temp = -8 + Math.sin(i / 4) * 3;
  const precipitation = i >= 2 && i <= 8 ? 80 + Math.random() * 20 : Math.random() * 30;
  return {
    time,
    temp: Math.round(temp),
    precipitation: Math.round(precipitation),
    condition: precipitation > 60 ? 'snow' : precipitation > 30 ? 'cloudy' : 'clear'
  };
});
export function ForecastTimeline() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-635">
      <div className="flex items-center justify-between mb-4" data-id="element-636">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-637">
          Prévisions horaires
        </h2>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-638">
          Prochains 7 jours →
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-639">
        <div className="flex space-x-4 pb-4" data-id="element-640">
          {hourlyForecast.map((hour, index) => <div key={index} className="flex-shrink-0 w-20 text-center p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-641">
              <p className="text-xs text-gray-600 font-medium" data-id="element-642">
                {format(hour.time, 'HH:mm')}
              </p>
              <div className="my-3 flex justify-center" data-id="element-643">
                {hour.condition === 'snow' ? <CloudSnow className="w-8 h-8 text-blue-500" data-id="element-644" /> : hour.condition === 'cloudy' ? <Cloud className="w-8 h-8 text-gray-400" data-id="element-645" /> : <Sun className="w-8 h-8 text-yellow-500" data-id="element-646" />}
              </div>
              <p className="text-lg font-bold text-gray-900" data-id="element-647">{hour.temp}°</p>
              <div className="mt-2" data-id="element-648">
                <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden" data-id="element-649">
                  <div className="h-full bg-blue-500 rounded-full" style={{
                width: `${hour.precipitation}%`
              }} data-id="element-650" />
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-651">
                  {hour.precipitation}%
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}